import {
  Accordion, AccordionSummary, AccordionDetails,
  Box, Typography, Chip, List, ListItem, ListItemIcon, ListItemText, Paper,
} from '@mui/material';
import {
  ExpandMore as ExpandIcon,
  LocalHospital as InpatientIcon,
  CheckCircle as MetIcon,
  Error as GapIcon,
} from '@mui/icons-material';
import type { InpatientAnalysisView } from '../../../../../services/MedNecService';

interface InpatientAnalysisPanelProps {
  analysis: InpatientAnalysisView;
}

const InpatientAnalysisPanel: React.FC<InpatientAnalysisPanelProps> = ({ analysis }) => (
  <Accordion defaultExpanded>
    <AccordionSummary expandIcon={<ExpandIcon />}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <InpatientIcon color="primary" />
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Inpatient Analysis</Typography>
        <Chip
          size="small"
          label={analysis.recommendation.replace(/_/g, ' ')}
          color={
            analysis.recommendation === 'INP_YES' ? 'success'
              : analysis.recommendation === 'INP_POSS' ? 'warning'
              : 'error'
          }
          variant="outlined"
        />
      </Box>
    </AccordionSummary>
    <AccordionDetails>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {analysis.inpatientCriteriaMet.length > 0 && (
          <Box>
            <Typography variant="caption" sx={{ fontWeight: 600 }}>Criteria Met:</Typography>
            <List dense disablePadding>
              {analysis.inpatientCriteriaMet.map((item, i) => (
                <ListItem key={i} sx={{ py: 0 }}>
                  <ListItemIcon sx={{ minWidth: 28 }}><MetIcon fontSize="small" color="success" /></ListItemIcon>
                  <ListItemText primary={item} primaryTypographyProps={{ variant: 'body2' }} />
                </ListItem>
              ))}
            </List>
          </Box>
        )}
        {analysis.inpatientCriteriaGaps.length > 0 && (
          <Box>
            <Typography variant="caption" sx={{ fontWeight: 600 }}>Criteria Gaps:</Typography>
            <List dense disablePadding>
              {analysis.inpatientCriteriaGaps.map((item, i) => (
                <ListItem key={i} sx={{ py: 0 }}>
                  <ListItemIcon sx={{ minWidth: 28 }}><GapIcon fontSize="small" color="error" /></ListItemIcon>
                  <ListItemText primary={item} primaryTypographyProps={{ variant: 'body2' }} />
                </ListItem>
              ))}
            </List>
          </Box>
        )}
        {analysis.samplePhysicianStatement && (
          <Paper variant="outlined" sx={{ p: 1.5, bgcolor: '#f8f9fa' }}>
            <Typography variant="caption" sx={{ fontWeight: 600, display: 'block', mb: 0.5 }}>
              Sample Physician Statement:
            </Typography>
            <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
              {analysis.samplePhysicianStatement}
            </Typography>
          </Paper>
        )}
      </Box>
    </AccordionDetails>
  </Accordion>
);

export default InpatientAnalysisPanel;
